<template>
    <div class="py-4 bg-secondary">
        <div class="profile-page">
            <section class="section-new">
                <div class="container">
                    <el-row>
                        <el-col :span="24">
                            <div class="card card-lift shadow border-0 card-address_page mb-3">
                                <el-breadcrumb separator-class="el-icon-arrow-right" class="vertical-center">
                                    <el-breadcrumb-item :to="{ path: '/' }">{{$t('menu.main')}}</el-breadcrumb-item>
                                    <el-breadcrumb-item>{{$t('menu.pro_about')}}</el-breadcrumb-item>
                                    <el-breadcrumb-item>{{$t('menu.pro_structure')}}</el-breadcrumb-item>
                                </el-breadcrumb>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </section>

            <section class="section py-3">
                <div class="container">
                <el-row :gutter="15" class="instiative_mobi">
                    <el-col :sm="24" :md="24" :lg="24" class="mb-3 mb-lg-10">
                        <div class="card card-lift shadow border-1 card_tuzilma">
                            <img src="img/icons/tuzilma/tuzilma.png" class="image_tuzilma">
                        </div>
                    </el-col>
                </el-row>
<!--                <el-row :gutter="15" class="instiative_mobi">-->
<!--                    <div style="flex: 1;"></div>-->
<!--                    <el-col :sm="24" :md="8" :lg="6" class="mb-3 mb-lg-10">-->
<!--                        <div class="card card-lift shadow border-1 card-instiative1">-->
<!--                            <img src="img/icons/tuzilma/manager.svg" class="image_instiative1">-->
<!--                            <span class="card_span_instiative1 vertical-center"><strong>{{$t('tuzilma.pro_title')}}</strong></span>-->
<!--                        </div>-->
<!--                    </el-col>-->
<!--                    <div style="flex: 1;"></div>-->
<!--                </el-row>-->
<!--                <el-row :gutter="15">-->
<!--                    <el-col :sm="12" :md="8" :lg="6" class="mb-3 mb-lg-10">-->
<!--                        <div class="card card-lift shadow border-1 card-instiative1">-->
<!--                            <img src="img/icons/tuzilma/businessman.svg" class="image_instiative1">-->
<!--                            <span class="card_span_instiative1 vertical-center"><strong>{{$t('tuzilma.pro_title1')}}</strong></span>-->
<!--                        </div>-->
<!--                    </el-col>-->
<!--                    <el-col :sm="12" :md="8" :lg="6" class="mb-3 mb-lg-10">-->
<!--                        <div class="card card-lift shadow border-1 card-instiative1">-->
<!--                            <img src="img/icons/tuzilma/employee.svg" class="image_instiative1">-->
<!--                            <span class="card_span_instiative1 vertical-center"><strong>{{$t('tuzilma.pro_title2')}}</strong></span>-->
<!--                        </div>-->
<!--                    </el-col>-->
<!--                    <el-col :sm="12" :md="8" :lg="6" class="mb-3 mb-lg-10">-->
<!--                        <div class="card card-lift shadow border-1 card-instiative1">-->
<!--                            <img src="img/icons/tuzilma/worker.svg" class="image_instiative1">-->
<!--                            <span class="card_span_instiative1 vertical-center"><strong>{{$t('tuzilma.pro_title3')}}</strong></span>-->
<!--                        </div>-->
<!--                    </el-col>-->
<!--                    <el-col :sm="12" :md="8" :lg="6" class="mb-3 mb-lg-10">-->
<!--                        <div class="card card-lift shadow border-1 card-instiative1">-->
<!--                            <img src="img/icons/tuzilma/team.svg" class="image_instiative1">-->
<!--                            <span class="card_span_instiative1 vertical-center"><strong>{{$t('tuzilma.pro_title4')}}</strong></span>-->
<!--                        </div>-->
<!--                    </el-col>-->
<!--                    <el-col :sm="12" :md="8" :lg="6" class="mb-3 mb-lg-10">-->
<!--                        <div class="card card-lift shadow border-1 card-instiative1">-->
<!--                            <img src="img/icons/tuzilma/court.svg" class="image_instiative1">-->
<!--                            <span class="card_span_instiative1 vertical-center"><strong>{{$t('tuzilma.pro_title5')}}</strong></span>-->
<!--                        </div>-->
<!--                    </el-col>-->
<!--                    <el-col :sm="12" :md="8" :lg="6" class="mb-3 mb-lg-10">-->
<!--                        <div class="card card-lift shadow border-1 card-instiative1">-->
<!--                            <img src="img/icons/tuzilma/responsibility.svg" class="image_instiative1">-->
<!--                            <span class="card_span_instiative1 vertical-center"><strong>{{$t('tuzilma.pro_title6')}}</strong></span>-->
<!--                        </div>-->
<!--                    </el-col>-->
<!--                    <el-col :sm="12" :md="8" :lg="6" class="mb-3 mb-lg-10">-->
<!--                        <div class="card card-lift shadow border-1 card-instiative1">-->
<!--                            <img src="img/icons/tuzilma/analysis.svg" class="image_instiative1">-->
<!--                            <span class="card_span_instiative1 vertical-center"><strong>{{$t('tuzilma.pro_title7')}}</strong></span>-->
<!--                        </div>-->
<!--                    </el-col>-->
<!--                    <el-col :sm="12" :md="8" :lg="6" class="mb-3 mb-lg-10">-->
<!--                        <div class="card card-lift shadow border-1 card-instiative1">-->
<!--                            <img src="img/icons/tuzilma/wildfire.svg" class="image_instiative1">-->
<!--                            <span class="card_span_instiative1 vertical-center"><strong>{{$t('tuzilma.pro_title8')}}</strong></span>-->
<!--                        </div>-->
<!--                    </el-col>-->
<!--                    <el-col :sm="12" :md="8" :lg="6" class="mb-3 mb-lg-10">-->
<!--                        <div class="card card-lift shadow border-1 card-instiative1">-->
<!--                            <img src="img/icons/tuzilma/lawyer.svg" class="image_instiative1">-->
<!--                            <span class="card_span_instiative1 vertical-center"><strong>{{$t('tuzilma.pro_title9')}}</strong></span>-->
<!--                        </div>-->
<!--                    </el-col>-->
<!--                    <el-col :sm="12" :md="8" :lg="6" class="mb-3 mb-lg-10">-->
<!--                        <div class="card card-lift shadow border-1 card-instiative1">-->
<!--                            <img src="img/icons/tuzilma/infographic.svg" class="image_instiative1">-->
<!--                            <span class="card_span_instiative1 vertical-center"><strong>{{$t('tuzilma.pro_title10')}}</strong></span>-->
<!--                        </div>-->
<!--                    </el-col>-->
<!--                    <el-col :sm="12" :md="8" :lg="6" class="mb-3 mb-lg-10">-->
<!--                        <div class="card card-lift shadow border-1 card-instiative1">-->
<!--                            <img src="img/icons/tuzilma/group.svg" class="image_instiative1">-->
<!--                            <span class="card_span_instiative1 vertical-center"><strong>{{$t('tuzilma.pro_title11')}}</strong></span>-->
<!--                        </div>-->
<!--                    </el-col>-->
<!--                    <el-col :sm="12" :md="8" :lg="6" class="mb-3 mb-lg-10">-->
<!--                        <div class="card card-lift shadow border-1 card-instiative1">-->
<!--                            <img src="img/icons/tuzilma/archive_c.svg" class="image_instiative1">-->
<!--                            <span class="card_span_instiative1 vertical-center"><strong>{{$t('tuzilma.pro_title12')}}</strong></span>-->
<!--                        </div>-->
<!--                    </el-col>-->
<!--                    <el-col :sm="12" :md="8" :lg="6" class="mb-3 mb-lg-10">-->
<!--                        <div class="card card-lift shadow border-1 card-instiative1">-->
<!--                            <img src="img/icons/tuzilma/employee_c.svg" class="image_instiative1">-->
<!--                            <span class="card_span_instiative1 vertical-center"><strong>{{$t('tuzilma.pro_title13')}}</strong></span>-->
<!--                        </div>-->
<!--                    </el-col>-->
<!--                    <el-col :sm="12" :md="8" :lg="6" class="mb-3 mb-lg-10">-->
<!--                        <div class="card card-lift shadow border-1 card-instiative1">-->
<!--                            <img src="img/icons/tuzilma/policeman.svg" class="image_instiative1">-->
<!--                            <span class="card_span_instiative1 vertical-center"><strong>{{$t('tuzilma.pro_title14')}}</strong></span>-->
<!--                        </div>-->
<!--                    </el-col>-->
<!--                    <el-col :sm="12" :md="8" :lg="6" class="mb-3 mb-lg-10">-->
<!--                        <div class="card card-lift shadow border-1 card-instiative1">-->
<!--                            <img src="img/icons/tuzilma/exchange.svg" class="image_instiative1">-->
<!--                            <span class="card_span_instiative1 vertical-center"><strong>{{$t('tuzilma.pro_title15')}}</strong></span>-->
<!--                        </div>-->
<!--                    </el-col>-->
<!--                    <el-col :sm="12" :md="8" :lg="6" class="mb-3 mb-lg-10">-->
<!--                        <div class="card card-lift shadow border-1 card-instiative1">-->
<!--                            <img src="img/icons/tuzilma/case.svg" class="image_instiative1">-->
<!--                            <span class="card_span_instiative1 vertical-center"><strong>{{$t('tuzilma.pro_title16')}}</strong></span>-->
<!--                        </div>-->
<!--                    </el-col>-->
<!--                    <el-col :sm="12" :md="8" :lg="6" class="mb-3 mb-lg-10">-->
<!--                        <div class="card card-lift shadow border-1 card-instiative1">-->
<!--                            <img src="img/icons/tuzilma/identity.svg" class="image_instiative1">-->
<!--                            <span class="card_span_instiative1 vertical-center"><strong>{{$t('tuzilma.pro_title17')}}</strong></span>-->
<!--                        </div>-->
<!--                    </el-col>-->
<!--                    <el-col :sm="12" :md="8" :lg="6" class="mb-3 mb-lg-10">-->
<!--                        <div class="card card-lift shadow border-1 card-instiative1">-->
<!--                            <img src="img/icons/tuzilma/corruption.svg" class="image_instiative1">-->
<!--                            <span class="card_span_instiative1 vertical-center"><strong>{{$t('tuzilma.pro_title18')}}</strong></span>-->
<!--                        </div>-->
<!--                    </el-col>-->
<!--                    <el-col :sm="12" :md="8" :lg="6" class="mb-3 mb-lg-10">-->
<!--                        <div class="card card-lift shadow border-1 card-instiative1">-->
<!--                            <img src="img/icons/tuzilma/military.svg" class="image_instiative1">-->
<!--                            <span class="card_span_instiative1 vertical-center"><strong>{{$t('tuzilma.pro_title19')}}</strong></span>-->
<!--                        </div>-->
<!--                    </el-col>-->
<!--                    <el-col :sm="12" :md="8" :lg="6" class="mb-3 mb-lg-10">-->
<!--                        <div class="card card-lift shadow border-1 card-instiative1">-->
<!--                            <img src="img/icons/tuzilma/bribe.svg" class="image_instiative1">-->
<!--                            <span class="card_span_instiative1 vertical-center"><strong>{{$t('tuzilma.pro_title20')}}</strong></span>-->
<!--                        </div>-->
<!--                    </el-col>-->
<!--                    <el-col :sm="12" :md="8" :lg="6" class="mb-3 mb-lg-10">-->
<!--                        <div class="card card-lift shadow border-1 card-instiative1">-->
<!--                            <img src="img/icons/tuzilma/news.svg" class="image_instiative1">-->
<!--                            <span class="card_span_instiative1 vertical-center"><strong>{{$t('tuzilma.pro_title21')}}</strong></span>-->
<!--                        </div>-->
<!--                    </el-col>-->
<!--                    <el-col :sm="12" :md="8" :lg="6" class="mb-3 mb-lg-10">-->
<!--                        <div class="card card-lift shadow border-1 card-instiative1">-->
<!--                            <img src="img/icons/tuzilma/computer.svg" class="image_instiative1">-->
<!--                            <span class="card_span_instiative1 vertical-center"><strong>{{$t('tuzilma.pro_title22')}}</strong></span>-->
<!--                        </div>-->
<!--                    </el-col>-->
<!--                    <el-col :sm="12" :md="8" :lg="6" class="mb-3 mb-lg-10">-->
<!--                        <div class="card card-lift shadow border-1 card-instiative1">-->
<!--                            <img src="img/icons/tuzilma/contract_c.svg" class="image_instiative1">-->
<!--                            <span class="card_span_instiative1 vertical-center"><strong>{{$t('tuzilma.pro_title23')}}</strong></span>-->
<!--                        </div>-->
<!--                    </el-col>-->
<!--                    <el-col :sm="12" :md="8" :lg="6" class="mb-3 mb-lg-10">-->
<!--                        <div class="card card-lift shadow border-1 card-instiative1">-->
<!--                            <img src="img/icons/tuzilma/suitcase.svg" class="image_instiative1">-->
<!--                            <span class="card_span_instiative1 vertical-center"><strong>{{$t('tuzilma.pro_title24')}}</strong></span>-->
<!--                        </div>-->
<!--                    </el-col>-->
<!--                    <el-col :sm="12" :md="8" :lg="6" class="mb-3 mb-lg-10">-->
<!--                        <div class="card card-lift shadow border-1 card-instiative1">-->
<!--                            <img src="img/icons/tuzilma/globe.svg" class="image_instiative1">-->
<!--                            <span class="card_span_instiative1 vertical-center"><strong>{{$t('tuzilma.pro_title25')}}</strong></span>-->
<!--                        </div>-->
<!--                    </el-col>-->
<!--                    <el-col :sm="12" :md="8" :lg="6" class="mb-3 mb-lg-10">-->
<!--                        <div class="card card-lift shadow border-1 card-instiative1">-->
<!--                            <img src="img/icons/tuzilma/auction.svg" class="image_instiative1">-->
<!--                            <span class="card_span_instiative1 vertical-center"><strong>{{$t('tuzilma.pro_title26')}}</strong></span>-->
<!--                        </div>-->
<!--                    </el-col>-->
<!--                    <el-col :sm="12" :md="8" :lg="6" class="mb-3 mb-lg-10">-->
<!--                        <div class="card card-lift shadow border-1 card-instiative1">-->
<!--                            <img src="img/icons/tuzilma/book.svg" class="image_instiative1">-->
<!--                            <span class="card_span_instiative1 vertical-center"><strong>{{$t('tuzilma.pro_title27')}}</strong></span>-->
<!--                        </div>-->
<!--                    </el-col>-->
<!--                    <el-col :sm="12" :md="8" :lg="6" class="mb-3 mb-lg-10">-->
<!--                        <div class="card card-lift shadow border-1 card-instiative1">-->
<!--                            <img src="img/icons/tuzilma/newspaper.svg" class="image_instiative1">-->
<!--                            <span class="card_span_instiative1 vertical-center"><strong>{{$t('tuzilma.pro_title34')}}</strong></span>-->
<!--                        </div>-->
<!--                    </el-col>-->
<!--                    <el-col :sm="12" :md="8" :lg="6" class="mb-3 mb-lg-10">-->
<!--                        <div class="card card-lift shadow border-1 card-instiative1">-->
<!--                            <img src="img/icons/tuzilma/campus.svg" class="image_instiative1">-->
<!--                            <span class="card_span_instiative1 vertical-center"><strong>{{$t('tuzilma.pro_title32')}}</strong></span>-->
<!--                        </div>-->
<!--                    </el-col>-->
<!--                    <el-col :sm="12" :md="8" :lg="6" class="mb-3 mb-lg-10">-->
<!--                        <div class="card card-lift shadow border-1 card-instiative1">-->
<!--                            <img src="img/icons/tuzilma/document.svg" class="image_instiative1">-->
<!--                            <span class="card_span_instiative1 vertical-center"><strong>{{$t('tuzilma.pro_title28')}}</strong></span>-->
<!--                        </div>-->
<!--                    </el-col>-->
<!--                    <el-col :sm="12" :md="8" :lg="6" class="mb-3 mb-lg-10">-->
<!--                        <div class="card card-lift shadow border-1 card-instiative1">-->
<!--                            <img src="img/icons/tuzilma/report.svg" class="image_instiative1">-->
<!--                            <span class="card_span_instiative1 vertical-center"><strong>{{$t('tuzilma.pro_title29')}}</strong></span>-->
<!--                        </div>-->
<!--                    </el-col>-->
<!--                    <el-col :sm="12" :md="8" :lg="6" class="mb-3 mb-lg-10">-->
<!--                        <div class="card card-lift shadow border-1 card-instiative1">-->
<!--                            <img src="img/icons/tuzilma/research.svg" class="image_instiative1">-->
<!--                            <span class="card_span_instiative1 vertical-center"><strong>{{$t('tuzilma.pro_title30')}}</strong></span>-->
<!--                        </div>-->
<!--                    </el-col>-->
<!--                    <el-col :sm="12" :md="8" :lg="6" class="mb-3 mb-lg-10">-->
<!--                        <div class="card card-lift shadow border-1 card-instiative1">-->
<!--                            <img src="img/icons/tuzilma/mountain.svg" class="image_instiative1">-->
<!--                            <span class="card_span_instiative1 vertical-center"><strong>{{$t('tuzilma.pro_title31')}}</strong></span>-->
<!--                        </div>-->
<!--                    </el-col>-->

<!--                </el-row>-->
                </div>
            </section>
        </div>
    </div>
</template>
<script>
    export default {};
</script>
<style scoped>
    /deep/ .px-4 {
        min-height: 356px;
    }

    /deep/ .profile-page .card-profile {
        margin-top: 70px;
    }
</style>
